import React from 'react';
import { cn } from '@/lib/utils';
import { normalizeCoverDisplay } from '../../utils/coverDisplay';

/**
 * Renders an archive cover photo with optional fit/fill, position, and zoom.
 */
export function ArchiveCoverImage({
  src,
  alt = '',
  coverDisplay,
  className,
  imageClassName,
  showGradient = true,
}) {
  const display = normalizeCoverDisplay(coverDisplay);
  const { fit_mode, pos_x, pos_y, zoom } = display;
  const objectPosition = `${pos_x}% ${pos_y}%`;
  const transformOrigin = objectPosition;
  const isFit = fit_mode === 'fit';

  const imageStyle = {
    objectPosition,
    transform: zoom !== 1 ? `scale(${zoom})` : undefined,
    transformOrigin,
  };

  return (
    <div className={cn('relative h-full w-full overflow-hidden', className)}>
      {isFit ? (
        <>
          <img
            src={src}
            alt=""
            aria-hidden
            className="absolute inset-0 h-full w-full scale-110 object-cover blur-2xl brightness-[0.92] saturate-[0.85]"
            style={{ objectPosition }}
            loading="lazy"
            decoding="async"
          />
          <div
            className="absolute inset-0 bg-gradient-to-br from-[hsl(42_30%_96%)]/85 via-[hsl(40_24%_94%)]/75 to-[hsl(38_20%_90%)]/80"
            aria-hidden
          />
        </>
      ) : null}
      <img
        src={src}
        alt={alt}
        className={cn(
          'absolute inset-0 h-full w-full',
          isFit ? 'object-contain' : 'object-cover',
          imageClassName
        )}
        style={imageStyle}
        loading="lazy"
        decoding="async"
      />
      {showGradient ? (
        <div
          className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[hsl(28_12%_18%/_0.12)] via-transparent to-transparent"
          aria-hidden
        />
      ) : null}
    </div>
  );
}
